import alertSound from '@assets/sounds/alert.mp3';
import notificationSound from '@assets/sounds/notification.mp3';

const notificationAudio = new Audio(notificationSound);
const alertAudio = new Audio(alertSound);

export const playNotificationSound = () => {
  notificationAudio.currentTime = 0; // Reset playback position
  notificationAudio.play().catch((error) => {
    console.error('Error playing notification sound:', error);
  });
};

export const playAlertSound = () => {
  alertAudio.currentTime = 0; // Reset playback position
  alertAudio.play().catch((error) => {
    console.error('Error playing alert sound:', error);
  });
};
